<app-navbar title="Testing..."></app-navbar>

<app-editor [(value)]="content"></app-editor>
<p>Value output: {{ content | json }}</p>
<hr />
<app-editor [(value)]="content2"></app-editor>
<p>Value output: {{ content2 | json }}</p>
